import angular from 'angular';
import constants from 'app/constants/index';
import {
  pmDataService,
  loaderService,
  ssDialogService,
} from 'app/services/index';
import {
  alerts,
  confirmDialog,
} from 'app/components/global/index';
import editDocumentAttachmentDialog from '../dialog.editDocumentAttachmentDialog';
import completedDocumentAttachment from './completedDocumentAttachment';
import controller from './completed-document.controller';
import directive from './completed-document.directive';

export default angular.module('app.components.advisory.pm.completedDocument', [
  alerts,
  pmDataService,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  editDocumentAttachmentDialog,
  completedDocumentAttachment,
])
  .directive('pmCompletedDocument', directive)
  .controller('CompletedPmDocumentController', controller)
  .name;

console.log('app.components.advisory.pm.completedDocument created');
